import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import FilmData from "./Components/Main/FilmData.jsx";
import AppWrapper from "./Components/AppWrapper";
import Auth from "./Components/Auth/Auth";
import GetEPG from "./Components/Main/GetEPG";
import { Box } from "@mui/material";
import { useState } from "react";
import { BASE_API_URL } from "./Components/const";

function App() {
  const [hideMetUid] = useState(
    () =>
      new URL(BASE_API_URL).hostname === "api.vlc-control.lionsarena.md" ||
      new URL(BASE_API_URL).hostname === "api.cinema.idc.md"
  );

  const isAuthenticated = () => {
    return (
      localStorage.getItem("IDCcinema.Login") &&
      localStorage.getItem("IDCcinema.Token")
    );
  };
  return (
    <Router>
      <Box sx={{ height: "100vh" }}>
        <Routes>
          {/* <Route path="/" element={<AppWrapper />} /> */}
          <Route
            path="/"
            element={
              isAuthenticated() ? (
                <AppWrapper hideMetUid={hideMetUid} />
              ) : (
                <Navigate to="/auth" />
              )
            }
          />
          <Route
            path="/auth"
            element={
              <Auth onAuthSuccess={() => (window.location.href = "/")} />
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
          <Route
            path="/filmdata"
            element={<FilmData hideMetUid={hideMetUid} />}
          />
          <Route path="/met" element={<GetEPG hideMetUid={hideMetUid} />} />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;
